/**  Представление отображения графа */
import React from 'react'
import { Spin } from 'antd';

import ApiUtils from '../../virtuoso/ApiUtils';

import SPARQLGraph from '../../components/graph/SPARQLGraph';
import OWLGraph from '../../components/graph/OWLGraph';
import AnyGraph from '../../components/graph/AnyGraph';

import { makeSettings } from '../../utils/viewsUtil'
import i18n from "i18next";
//Для теста
import 'whatwg-fetch';

const isAnyInSettings = settings =>{
  return (settings && settings.settings && settings.settings.extra_options && (settings.settings.extra_options.type == "any"));
}

const getMessage = record => {
  if (!record)
    return i18n.t('graph.process.START');
  switch (record.message) {
    case 1000: return i18n.t('graph.process.START_CONTENT')
    case 1001: return i18n.t('graph.process.CONTENT_RECEIVED')
    case 1002: return i18n.t('graph.process.START_CACHE')
    case 1003: return i18n.t('graph.process.FINISH_CACHE')
    case 1010: return i18n.t('graph.process.CONVERT_PREPARE')
    case 1011: return i18n.t('graph.process.CONVERT')
    case 1012: return i18n.t('graph.process.ERROR')
    default:
      return i18n.t('graph.process.START');;
  }
}

//Функция, которая опрашивает сервер, пока основной запрос не завершён.
function startProcessPolling(ID, onUpdate, interval = 2000) {
  let stopped = false;
  let timer = null;

  const poll = () => {
    if (stopped) return;    

    ApiUtils.getProcessInfoViaLiferay(ID)
      .then(info => {
        onUpdate(info);

        if (info.finished) {
          stopped = true;
          return;
        }

        if (!stopped) {
          timer = setTimeout(poll, interval);
        }
      })
      .catch(error => {
        if (!stopped) {
          timer = setTimeout(poll, interval);
        }
      });
  };

  poll();

  return {
    stop() {
      stopped = true;
      if (timer) {
        clearTimeout(timer);
      }
    }
  };
};


/** Представление обеспечивает загрузку данных с использованием SPARQL запроса, 
 * и отборажение его с использованием SPARQLGraph 
 * */
class GraphComponent extends React.Component {

  constructor(props) {
    super(props);
    //view - идентификатор представления
    //description - описание представления
    //settings - параметры для графа
    //loaded - флаг загрузки
		this.state = {
      view: null, description: null, settings: null, loaded: false, message: i18n.t('graph.process.START'),
    //Параметры отслеживания процесса получения графа
      loading: false, progress: 0, progressIndeterminate: false, processMessages: [], processFinished: false, error: null
    };
  }
  
	componentDidMount(){
    this.loadContent();
	}

  static getDerivedStateFromProps(props, state) {
    //console.log("GraphComponent.js static getDerivedStateFromProps(props, state)", props, state);
    if ((props.settings && (JSON.stringify(props.settings) !== JSON.stringify(state.settings))) ||
        (JSON.stringify(props.view) != JSON.stringify(state.view))) {
      return {
        view: null, description: null, settings: null, loaded: false
      };
    }
    return null; // Return null to indicate no change to state.
  }

  loadContent(){
    if (this.state.loaded) return;
    //console.log("GraphComponent.js loadContent()", this);
    //Параметры заданы стразу
    if (this.props.settings){
      const {endpoint, graph, sparql} = this.props.settings;
      const options = {headers:{'Content-type': 'application/json'}, endpointUrl: endpoint};
      return ApiUtils.queryViaLiferay(sparql, graph)
      //return ApiUtils.fetch(sparql, graph, {}, options)
        .then(response => {
          //console.log("content", response);
          this.setState({ content: response, loaded: true, settings: this.props.settings, view: this.props.view});
        })  
    }
    //Первый шаг - загрузка  описания view
    if (!this.state.description){
      const {view, iri, model} = this.props;
      return model.getView(view.id)
        .then(response => {
          const description = response.view;
          return {description, settings: makeSettings(description)};
      //Второй шаг - загрузка содержимого
      }).then(response =>{
        const {description, settings} = response;
        const {endpoint, graph, sparql, type} = settings;
        ApiUtils.register_endpointUrl(endpoint);
        this.setState({loading: true,loaded: false, progress: 0,progressIndeterminate: true,
            processMessages: [],processFinished: false,error: null, message: i18n.t('graph.process.START')});

        let polling = null;
        // //Для теста
        // if (graph === "http://purl.semanticpro.org/data/CPIByCOICOPMonthCountryVsPrevYearDec"){
        //   return fetch("http://localhost:3000/CPIByCOICOPMonthCountryVsPrevYearDec.json?"+ new Date().getTime(), {}) 
        // // if (graph === "http://purl.cisstat.org/data/CPIByCOICOPMonthCountryVsPrevYearDec"){
        // //   return fetch("http://localhost:3000/sparql-vowl-output-big2.json", {}) 
        //     .then(response => {
        //       console.log("GraphComponent.js", response);
        //       return response.json();
        //     }).then(json => {
        //       this.setState({ description, vowl: json, loaded: true, settings, view});              
        //     //     resolve(json);
        //     // }).then(json => {
        //     });
        // }
        const ID = Date.now();
        if (type === "owl" || type === "sparql" ){
          polling = startProcessPolling(
              ID,
              info => {
                //console.log("GraphComponent.js loadContent() polling", info);
                if (Array.isArray(info.messages) && info.messages.length>0 && !this.state.loaded)
                  this.setState({message: getMessage(info.messages[info.messages.length-1])});
                this.setState(prevState => {
                  const newMessages = info.messages || [];
                  const hasNumericProgress = Number.isFinite(info.progress);

                  return {
                    processMessages: [...prevState.processMessages, ...newMessages],
                    processFinished: !!info.finished,
                    progress: hasNumericProgress ? info.progress : prevState.progress,
                    progressIndeterminate: !hasNumericProgress
                  };
                });
              },
              1000
            );

          return ApiUtils.presentationViaLiferay(JSON.stringify(description), ID)
            .then(content => {
              if (polling) polling.stop();              
              this.setState({ message: i18n.t('graph.process.FINISH')}, () => {
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                              this.setState({ description, vowl: content, loaded: true, settings, view});
                  })
                })
              });              
            })
            .catch(error => {
              if (polling) polling.stop();
              //Вдруг ещё старый mpo сервис и метода нет
              return ApiUtils.queryViaLiferay(sparql, graph)
                .then(content => {
                  this.setState({ description, content, loaded: true, settings, view});
                })  
            });
        } else
          return ApiUtils.queryViaLiferay(sparql, graph)
            .then(content => {
              this.setState({ description, content, loaded: true, settings, view});
            })  
      })
    }
  }

  
  render(){
    console.log(this); //console.log(JSON.stringify(this.state.settings));console.log(JSON.stringify(this.state.content));
    const {message, loaded } = this.state;
    if (!loaded)
      return(<div className="text-center"><Spin size="large"/><div>{message}</div></div>)
    if ((this.props.type == "owl") || (this.state.settings.type=="owl"))
      return (<OWLGraph content={this.state.content} vowl={this.state.vowl} settings={this.state.settings}/>)
      if ((this.props.type == "any") || (this.state.settings.type=="any") || isAnyInSettings(this.state.settings))
        return (<AnyGraph content={this.state.content} settings={this.state.settings}/>)
		return (
      <SPARQLGraph content={this.state.content} vowl={this.state.vowl} settings={this.state.settings}/>
    )
  }
}

export default GraphComponent;

